// extracted by mini-css-extract-plugin
module.exports = {"set-1-story":"stories-for-load-more-m__set-1-story__32NH6","stories":"stories-for-load-more-m__stories__K6Dd1","ad":"stories-for-load-more-m__ad__3Nudp"};